import React from "react";
import { Button } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useWorkspaceConfig } from "../../context/WorkspaceConfigContext";
import {
  buildExternalRegistrationUrl,
  EXTERNAL_REGISTRATION_CONFIG_KEY,
} from "../../utils/externalRegistrationLink";

export function useExternalRegistrationUrl(idInterno) {
  const { byKey } = useWorkspaceConfig();
  const baseUrl = byKey(EXTERNAL_REGISTRATION_CONFIG_KEY, false, "");
  return buildExternalRegistrationUrl(baseUrl, idInterno);
}

export default function ExternalRegistrationButton({
  idInterno,
  fullWidth = false,
  size = "medium",
  sx,
  label = "Cadastro externo",
}) {
  const { byKey } = useWorkspaceConfig();
  const baseUrl = byKey(EXTERNAL_REGISTRATION_CONFIG_KEY, false, "");
  const url = buildExternalRegistrationUrl(baseUrl, idInterno);

  if (!url) return null;

  return (
    <Button
      variant="outlined"
      color="inherit"
      fullWidth={fullWidth}
      size={size}
      startIcon={<OpenInNewIcon />}
      component="a"
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      sx={{ textTransform: "uppercase", ...(sx || {}) }}
    >
      {label}
    </Button>
  );
}
